import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {takeLatest, call} from 'redux-saga/effects';

import {getDealUnsignedURLSaga} from 'api/deals';

const namespace = 'flows/docs/unsigned';

// Actions
export const LOAD = defineAction('LOAD', namespace);
export const load = createAction(LOAD.ACTION);

// LoggedIn Saga
export function* retrieveDealUnsignedSaga({payload}) {
  // Call api
  const {id} = payload;
  // Get pre signed url
  const url = yield call(getDealUnsignedURLSaga, {payload: {id}});
  // Redirect
  window.location = url
}

export function* sagas() {
  yield takeLatest(LOAD.ACTION, retrieveDealUnsignedSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/docs/unsigned/index.js